export interface EventTypeDefinition {
  slug: string;
  labelDa: string;
  icon: string;
  cssClass: string;
}

export const EVENT_TYPES: EventTypeDefinition[] = [
  { slug: 'education', labelDa: 'Uddannelse', icon: 'school', cssClass: 'type-education' },
  { slug: 'course', labelDa: 'Kursus', icon: 'menu_book', cssClass: 'type-course' },
  { slug: 'exercise', labelDa: 'Øvelse', icon: 'fitness_center', cssClass: 'type-exercise' },
  { slug: 'activity', labelDa: 'Aktivitet', icon: 'event_available', cssClass: 'type-activity' },
];

export const EVENT_TYPE_FILTER_LABELS: Record<string, string> = {
  education: 'Uddannelser',
  course: 'Kurser',
  exercise: 'Øvelser',
  activity: 'Aktiviteter',
};

export function getEventTypeDefinition(slug: string): EventTypeDefinition | undefined {
  return EVENT_TYPES.find((t) => t.slug === slug);
}

export function getEventTypeLabel(slug: string): string {
  return getEventTypeDefinition(slug)?.labelDa ?? 'Begivenhed';
}

export function getEventTypeIcon(slug: string): string {
  return getEventTypeDefinition(slug)?.icon ?? 'event';
}

export function getEventTypeCssClass(slug: string): string {
  return getEventTypeDefinition(slug)?.cssClass ?? 'type-default';
}
